import { PromiseEnvelope } from '@types';
import { FetchSendLogsData } from '../types';
import { apiTelemedicine } from '../api';

export const fetchSendLogs = (body: FetchSendLogsData): PromiseEnvelope<void> =>
  apiTelemedicine.post('conference/logs', body);
